import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import wixData from 'wix-data';

let slideEffect = { "duration": 250, "delay": 0, "direction": "bottom" };
let fadeEffect = { "duration": 250, "delay": 0 };

const repeaterSizeDesktop = 3;
const repeaterSizeMobile = 1;
let repeaterSize;
let productsLength;
let currentIndex = 0;

$w.onReady(async function () {
    let formFactor = wixWindow.formFactor;
    if (formFactor === "Desktop") {
        repeaterSize = repeaterSizeDesktop;
    } else {
        repeaterSize = repeaterSizeMobile;
    }
    wixData.query("Stores/Products").hasSome("collections", ["8c957621-880d-3bea-5c32-c35a95507122"]).limit(100).descending("_updatedDate").find()
        .then((products) => {
            productsLength = products.items.length;
            console.log("productsLength: " + productsLength);
        })

    //set data
    await setRepeaterData("");

    //next page
    $w("#next").onClick((event) => {
        //currentIndex = currentIndex + repeaterSize;
        setRepeaterData("next");
        if (currentIndex + repeaterSize >= productsLength) {
            $w("#next").disable();
        } else {
            $w("#next").enable();
        }
    })

    //prev page
    $w("#prev").onClick((event) => {
        //currentIndex = currentIndex - repeaterSize;
        setRepeaterData("prev");
    })
})

export function setPictureUrl(image) {
    image = image.substr(15);
    image = image.slice(0, image.lastIndexOf("/"));
    let picutre = "https://static.wixstatic.com/media/".concat(image);
    return picutre;
}

export async function setRepeaterData(button) {
    let arrData = [];
    $w("#rpProducts").hide("fade", fadeEffect);
     wixData.query("Stores/Products").hasSome("collections", ["8c957621-880d-3bea-5c32-c35a95507122"]).limit(100).descending("_updatedDate").find()
        .then(async (products) => {
            if (button === "next") {
                $w("#prev").enable();
                arrData = [];
                for (let i = currentIndex; i < currentIndex + repeaterSize; i++) {
                    if (products.items[i]) {
                        arrData.push(products.items[i]);
                        if (currentIndex + repeaterSize > products.items.length) {
                            $w("#next").disable();
                        }
                    } else {
                        $w("#next").disable();
                        break;
                    }
                }
                currentIndex = currentIndex + repeaterSize;
                if (currentIndex >= products.items.length) {
                    currentIndex = products.items.length;
                    $w("#next").disable();
                }
                console.log("next2: " + currentIndex, currentIndex + repeaterSize);
            } else if (button === "prev") {
                $w("#next").enable();
                arrData = [];
                currentIndex = currentIndex - repeaterSize;
                if (currentIndex <= 0) {
                    currentIndex = 0;
                    $w("#prev").disable();
                }
                for (let i = currentIndex - repeaterSize; i < currentIndex; i++) {
                    if (products.items[i]) {
                        arrData.push(products.items[i]);
                        if (currentIndex - repeaterSize <= 0) {
                            $w("#prev").disable();
                        }
                    } else {
                        $w("#prev").disable();
                        break;
                    }
                }

                console.log("prev2: " + currentIndex, currentIndex - repeaterSize);
            } else if (button === "") {
                arrData = [];
                for (let i = currentIndex; i < currentIndex + repeaterSize; i++) {
                    if (products.items[i]) {
                        arrData.push(products.items[i]);
                    } else {
                        $w("#prev").disable();
                        break;
                    }
                }
                currentIndex = currentIndex + repeaterSize;
                if (currentIndex > products.items.length) {
                    currentIndex = products.items.length;
                }
            }
            $w("#rpProducts").data = arrData;
            $w("#rpProducts").onItemReady(($item, itemData, index) => {
                $item("#image").src = setPictureUrl(itemData.mainMedia);
                $item("#title").text = itemData.name;
                $item("#originalPrice").text = itemData.formattedPrice;
                if (itemData.formattedPrice !== itemData.formattedDiscountedPrice) {
                    $item("#original").show();
                }
                $item("#price").text = String(itemData.formattedDiscountedPrice);
                $item("#image").fitMode = "fill";
                $item("#hover").fitMode = "fill";
                //hover
                if (itemData.mediaItems[1]) {
                    $item("#hover").src = setPictureUrl(itemData.mediaItems[1].src);
                }
                if (!itemData.inStock) {
                    $item("#price").hide();
                    $item("#outOfStock").show();
                }

                //ribbon
                let ribbon = itemData.ribbons[0];
                if (ribbon) {
                    $item("#ribbon").text = ribbon.text;
                    $item("#boxRibbon").show();
                }

                //quick view
                $item("#image").onMouseIn((event) => {
                    if (itemData.mediaItems[1]) {
                        $item("#hover").src = setPictureUrl(itemData.mediaItems[1].src);
                        $item("#hover").show("fade", fadeEffect);
                    }
                    //$item("#textQuick").show();
                    $item("#quickView").show("slide", slideEffect);
                })
                $item("#product").onMouseOut((event) => {
                    $item("#quickView").hide("slide", slideEffect);
                    if (itemData.mediaItems[1]) {
                        $item("#hover").hide("fade", fadeEffect);
                    }
                })
                $item("#image").onClick((event) => {
                    console.log("/product/" + replaceSpace(itemData.slug));
                    wixLocation.to("/product/" + replaceSpace(itemData.slug));
                })
                $item("#hover").onClick((event) => {
                    console.log("/product/" + replaceSpace(itemData.slug));
                    wixLocation.to("/product/" + replaceSpace(itemData.slug));
                })

                //open quickView lightbox
                $item("#quickView").onClick((event) => {
                    wixWindow.openLightbox("quickView", itemData);
                })

                $w("#rpProducts").show("fade", fadeEffect);
            })
        })
        .catch((err) => {
            console.log(err);
        })
}

export function replaceSpace(str) {
    str = str.trim();
    var ar = [];
    ar = str.split("");

    let i;
    for (i = 0; i < ar.length; i++) {
        ar[i] = ar[i].replace(" ", "-");
        //ar[i] = ar[i].replace(",", "%2C");
        //ar[i] = ar[i].replace("'", "%27");
    }
    let output = ar.join("");
    return output;
}

/*import wixData from 'wix-data';

const PER_PAGE = 4;
let currentPage = 0;
let loadedProducts = [];

$w.onReady(function () {
	loadItems(0);
});

export function loadItems(page = 0) {
  wixData.query('Stores/Products')
    .hasSome('collections.id', ['8c957621-880d-3bea-5c32-c35a95507122'])
    .ascending('price')
	  .skip(page * PER_PAGE)
    .limit(PER_PAGE)
    .find()
    .then((res) => {
      if(res.items.length === 0) {
        return true;
      }

      let titleStyle = 'font-family: almoni-dl-aaa-400, sans-serif; font-size: 15px; font-weight: 600; color: #242d36; text-align: center; display: block;';

      let nextPage = page + 1;
      if(res.totalCount <= nextPage * PER_PAGE) {
        $w("#loadMore").hide("fade");
      }

	    res.items.forEach((item) => {
		    loadedProducts.push(item);
	    });

      $w("#repeater1").data = loadedProducts;

      $w("#repeater1").forEachItem(($item, itemData, index) => {
        $item("#productTitle").html = `<a href="/product/${itemData.slug}"><span style="${titleStyle}">${itemData.name}</span></a>`;
        $item("#productImage").src = getFullImageURL(itemData.mainMedia, 223, 227);
        $item("#productImage").link = `/product/${itemData.slug}`;
        
        $item("#productTitle").show();
        $item("#productImage").show();
      });

      $w("#repeater1").expand();
    })
    .catch((err) => console.error(err));
}

// this may break some day, Wix needs to supply a solution to pass proper image URLs to HTML Components
export function getFullImageURL(path, w, h) {
  path = path.replace("image://v1/", "").replace("wix:", "");
  path = path.split('/')[0];
  return `https://static.wixstatic.com/media/${path}/v1/fill/w_${w*2},h_${h*2},q_90,usm_0.66_1.00_0.01/${path}` ;
}

export function loadMore_click(event) {
	currentPage = currentPage + 1;
	loadItems(currentPage)

}*/